import classNames from 'classnames';
import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import Skeleton from 'react-loading-skeleton';

import { SectionTitle, TextBlock, NumList, List } from '@/ui/index';

import styles from './ServiceContent.module.scss';

const ServiceContent = ({ data, className }) => {
  let isImg = false;
  const router = useRouter();
  const isInternationalPage = router.query.dynamicPage.includes(
    'international-calls',
  );
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  const renderListItem = (item, index) => {
    return (
      <li
        key={index}
        className={styles.list_item}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        {item}
      </li>
    );
  };

  const renderAdditionalBlock = (() => {
    if (data?.text) {
      return (
        <TextBlock
          className={classNames(styles['service-content__text'], 'text--large')}
          itemScope
          itemType='https://schema.org/Text'
        >
          {data.text}
        </TextBlock>
      );
    }

    if (data?.additional?.bulletList?.length > 0) {
      return (
        <List itemScope itemType='https://schema.org/ItemList'>
          {data.additional.bulletList.map(renderListItem)}
        </List>
      );
    }

    if (data?.additional?.numList?.length > 0) {
      return (
        <NumList
          className={styles['service-content__num-list']}
          itemScope
          itemType='https://schema.org/ItemList'
        >
          {data.additional.numList.map(renderListItem)}
        </NumList>
      );
    }

    if (data?.image) {
      isImg = true;

      return (
        <div
          className={styles['service-content__img-wrapper']}
          itemScope
          itemType='https://schema.org/ImageGallery'
        >
          {!isImageLoaded && <Skeleton width={250} height={250} />}
          <Image
            className={styles['service-content__img']}
            src={data.image}
            alt='icon'
            loading='lazy'
            layout='fill'
            onLoadingComplete={() => setIsImageLoaded(true)}
            style={{
              visibility: isImageLoaded ? 'visible' : 'hidden',
            }}
          />
        </div>
      );
    }

    return false;
  })();

  return (
    <section
      className={classNames([styles['service-content'], className, 'section'])}
      itemScope
      itemType='https://schema.org/Service'
    >
      <div
        className={classNames([
          styles['service-content__wrapper'],
          { [styles['service-content__wrapper--row']]: isImg },
        ])}
      >
        <div>
          {data?.title && (
            <SectionTitle
              titleModify={classNames(
                styles['service-content__title'],
                'title--medium',
              )}
              icon={data?.icon}
            >
              {data.title}
            </SectionTitle>
          )}
          {data?.content && (
            <TextBlock
              className={classNames(
                styles['service-content__text'],
                'text--large',
                { [styles.callPage]: isInternationalPage },
              )}
              isHtml
            >
              {data.content}
            </TextBlock>
          )}
        </div>
        {renderAdditionalBlock}
      </div>
    </section>
  );
};

export default ServiceContent;
